import React, { useMemo, useState } from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { useCanEditFinalCustomer } from '../../../hooks/useCanEditFinalCustomer';
import { FormEditFinalCustomers } from '../../../components/finalCustomers/FormEditFinalCustomers';
import { ModalSearchCustomer } from '../../../components/finalCustomers/style';

export const ModalFinalCustomerAssigned = ({ show, finalCustomerId, handleClose }) => {
  const formName = useMemo(() => uuid(), []);
  const { translate: t } = useDictionaryTranslation();
  const canEditFinalCustomer = useCanEditFinalCustomer();
  const [showAction, setShowAction] = useState(false);

  // When reopening the modal for an already-assigned final customer, editing is
  // only allowed if the profile has the permission. Creating a new one is fine.
  const isBlockedEdit = Boolean(finalCustomerId) && !canEditFinalCustomer;

  const closeModal = ({ reloadData = false, customerData } = {}) => {
    handleClose(reloadData, customerData);
  };

  const onHandledSearch = ({ searchDone, searchReset } = {}) => {
    if (searchDone) setShowAction(true);
    if (searchReset) setShowAction(false);
  };

  const onFinishFormAction = async (result) => {
    const customerData = await result;
    closeModal({ reloadData: true, customerData });
  };

  return (
    <ModalSearchCustomer
      title={t('assignFinalCustomer')}
      width="90%"
      height="70%"
      onCancel={closeModal}
      destroyOnClose
      open={show}
      footer={
        <div>
          {isBlockedEdit ? null : (
            <Button
              form={formName}
              key="submit"
              htmlType="submit"
              type="primary"
              disabled={!showAction && !finalCustomerId}
            >
              {t('save')}
            </Button>
          )}
        </div>
      }
    >
      <FormEditFinalCustomers
        finalCustomerId={finalCustomerId}
        onFinish={onFinishFormAction}
        formName={formName}
        searchEnabled
        onHandledSearch={onHandledSearch}
      />
    </ModalSearchCustomer>
  );
};

ModalFinalCustomerAssigned.propTypes = {
  finalCustomerId: PropTypes.string,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
